import React, { Component, Fragment } from 'react';
import { Modal } from 'antd';
class ImgViewLg extends Component {

  state = {
    previewVisible: false,
  };

  render() {
    const { fileInfo, width, height, detailFileInfo, previewDisabled, viewGlass } = this.props;
    const { previewVisible }= this.state;
    return (
      
      fileInfo !== undefined && fileInfo !== null &&  (
        
        <Fragment>
          <img
            alt={encodeURIComponent(fileInfo.fileName)}
            style={{ width: width, height: height }} 
            src={process.env.REACT_APP_URL+`/file/imgView/?fileName=${encodeURIComponent(fileInfo.fileName)}&serverSubPath=${fileInfo.serverSubPath}&physicalName=${fileInfo.physicalName}`}
            // 사진 클릭했을때 팝업창 띄우기
            //onClick={()=>this.setState({ previewVisible: true })}
            />
          {viewGlass === true && 
            <span 
              className="glass_img" 
              role="img" 
              aria-label="d"
              onClick={()=>this.setState({ previewVisible: true })}
            > 🔍 </span>
          }
          {previewDisabled !== false &&
            <Modal
              visible={previewVisible}
              title={fileInfo.fileName}
              className="modalContentabc"
              footer={null}
              onCancel={()=>this.setState({ previewVisible: false })}
            >
              {detailFileInfo !== undefined && detailFileInfo !== null
              ? <img
                  alt={encodeURIComponent(detailFileInfo.fileName)}              
                  style={{ width: '3500px', height: '430px'}}   
                  src={process.env.REACT_APP_URL+`/file/imgView/?fileName=${encodeURIComponent(detailFileInfo.fileName)}&serverSubPath=${detailFileInfo.serverSubPath}&physicalName=${detailFileInfo.physicalName}`} 
                />
              : <img
                  alt={encodeURIComponent(fileInfo.fileName)}
                  style={{ width: '100%'}} 
                  src={process.env.REACT_APP_URL+`/file/imgView/?fileName=${encodeURIComponent(fileInfo.fileName)}&serverSubPath=${fileInfo.serverSubPath}&physicalName=${fileInfo.physicalName}`} 
                />
              }
            </Modal>
          }
        </Fragment>
        )
    );
  }

}

export default ImgViewLg;
